import React from "react";
import { Collapse } from "antd";
import { DropdownIcon } from "themes/Icon";
function CollapseComp({ className, data, active, setActive }) {
  const { Panel } = Collapse;

  const renderHeader = (item) => (
    <div className="accordion-title-container">
      {item.icon && (
        <span className={"accordion-header-icon"}>{item.icon} </span>
      )}
      <h5 className={"accordion-header-title"}>{item.label}</h5>
    </div>
  );

  const customExpandIcon = ({ isActive }) => (
    <span className={`${isActive ? "active" : ""}`}>
      <DropdownIcon />
    </span>
  );

  const onChange = (key) => {
    setActive(key);
  };

  return (
    <Collapse
      activeKey={active}
      expandIcon={customExpandIcon}
      expandIconPosition="end"
      className={className}
      onChange={onChange}
    >
      {data.map((item) => (
        <Panel header={renderHeader(item)} key={item.key}>
          {item.children}
        </Panel>
      ))}
    </Collapse>
  );
}

export default CollapseComp;
